import React from 'react';
import { Button, Flex, Modal, ModalBody, ModalContent, ModalFooter, ModalOverlay } from '@chakra-ui/react';
import { MdCheckCircle } from 'react-icons/md';
import classNames from 'classnames';
import { CloseIcon } from '@chakra-ui/icons';
import ReactIcon from '@/src/components/common/ReactIcon';

export const ConsultantFormPopup: React.FC<{
  isOpen: boolean;
  onClose: () => void;
  title?: React.ReactNode;
}> = ({ isOpen, onClose, children, title }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent
        marginY={{ base: '0' }}
        w={{
          base: 'full',
          sm: '600px',
        }}
        maxW={{
          sm: 'none',
        }}
        h={{
          base: 'full',
          sm: '325px',
        }}
        rounded={{
          base: 'none',
        }}
      >
        <ModalBody
          display={{ base: 'flex' }}
          flexDirection={{
            base: 'column',
          }}
          alignItems={{
            base: 'center',
          }}
          justifyContent={{
            base: 'center',
          }}
          py={{ base: '0' }}
          px={{ base: '0' }}
        >
          <Flex align={'center'} position={'absolute'} insetX={0} top={0} display={{ base: 'none', sm: 'flex' }}>
            {title}
            <Flex
              as={'button'}
              type={'button'}
              onClick={onClose}
              w={12}
              h={12}
              justifyContent={'center'}
              alignItems={'center'}
              ml={'auto'}
            >
              <CloseIcon w={4} h={4} />
            </Flex>
          </Flex>
          {children}
        </ModalBody>
        <ModalFooter py={{ base: 3 }} px={{ base: 4 }} display={{ sm: 'none' }}>
          <Button w={'full'} onClick={onClose}>
            確認
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export const GreetingPopup: React.FC<{
  isOpen: boolean;
  onClose: () => void;
  simple?: boolean;
}> = ({ isOpen, onClose, simple }) => {
  return (
    <ConsultantFormPopup isOpen={isOpen} onClose={onClose}>
      <div className={classNames('pb-6 sm:pb-0', 'sm:mb-8')}>
        <Flex w={{ base: '70px' }} h={{ base: '70px' }}>
          <ReactIcon icon={MdCheckCircle} className={classNames('text-gold', 'w-full h-full')} />
        </Flex>
      </div>
      <p
        className={classNames(
          'py-2 px-4',
          'sm:py-0 sm:px-0',
          'sm:mb-8',
          'text-headline2l',
          'sm:text-4xl',
          'text-gold font-medium',
          'text-center'
        )}
      >
        {simple ? '我們已收到您的回覆！' : '我們已收到您的資訊！'}
      </p>
      {!simple && (
        <p className={classNames('py-2 px-4', 'sm:py-0 sm:px-0', 'text-gray700', 'text-center')}>
          請查看您的 Email 信箱，我們已發送確認信
          <br />
          其他諮詢問題，歡迎撥打專線{' '}
          <a className={'underline'} href={`tel:${process.env.NEXT_PUBLIC_FUNWOO_TAIWAN_CELLPHONE}`}>
            {process.env.NEXT_PUBLIC_FUNWOO_TAIWAN_CELLPHONE}
          </a>{' '}
          或加官方 LINE{' '}
          <a
            className={'underline'}
            href={'https://liff.line.me/1645278921-kWRPP32q/?accountId=870wmpcf'}
            target={'_blank'}
            rel='noopener noreferrer'
          >
            @funwoo
          </a>
        </p>
      )}
    </ConsultantFormPopup>
  );
};
